import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../components/shared/Spinner";
import { toast } from "react-toastify";
import Layout from "../components/shared/Layout/Layout";
import Modal from "../components/shared/Modal/Modal";
import API from "../services/API";
import moment from "moment";

const Homepage = () => {
  const { loading, error, user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const getBloodRecords = async () => {
    try {
      const { data } = await API.get("/inventory/get-inventory");
      if (data?.success) {
        setData(data?.inventory);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBloodRecords();
  }, []);
  return (
    <Layout>
      {user?.role === "admin" && navigate("/admin")}
      {user?.role === "donar" && navigate("/donar")}
      {user?.role === "hospital" && navigate("/hospital")}
      {error && (
        <span style={{ display: "none" }}>{toast.error(error.payload)}</span>
      )}
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="container">
            <h4
              className="mx-auto"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              style={{ cursor: "pointer" }}
            >
              <i
                className="fa-solid fa-plus mx-2"
                style={{ color: "#ffffff" }}
              ></i>
              Add Inventory
            </h4>
            <div className="container donar-data">
              <table className="table table-hover">
                <thead>
                  <tr className="heading-fixed">
                    <th scope="col">Blood Group</th>
                    <th scope="col">Inventory Type</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Donar Email</th>
                    <th scope="col">Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((record) => (
                    <tr key={record._id}>
                      <td>{record.bloodGroup}</td>
                      <td>{record.inventoryType}</td>
                      <td>{record.quantity} ml</td>
                      <td>{record.email}</td>
                      <td>
                        {moment(record.createdAt).format("DD/MM/YYYY hh:mm A")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Modal />
          </div>
        </>
      )}
    </Layout>
  );
};

export default Homepage;
